import { SupportRequestFormData } from '@/components/mini-apps/support-request-form';

import { sendRequest } from './send-requests';

export const buildPayladoForSupportRequest = (data: SupportRequestFormData) => {
  return {
    accountHolder: data.accountHolder,
    firstName: data.firstName,
    lastName: data.lastName,
    mobileNumber: data.mobileNumber,
    email: data.email,
    requestFor: data.requestFor,
    lpaRegister: data.lpaRegister,
    lpaCode: data.lpaCode,
    contactPreference: data.contactPreference,
    contactPreferenceOtherDetail: data.contactPreferenceOtherDetail,
    nominate: data.nominate,
    nominee: data.nominee,
    support: data.support,
    consent: data.consent,
  };
};

export type SupportRequestDataPayloadType = ReturnType<typeof buildPayladoForSupportRequest>;

export const sendSupportRequest = async (data: SupportRequestFormData, recaptchaToken: string) => {
  const formData = buildPayladoForSupportRequest(data);

  return await sendRequest(formData, recaptchaToken);
};
